import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {Helmet} from 'react-helmet';
import parser from 'url-parse';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import { catalogMailingListsActions } from '../../data/actions/catalog_mailing_lists';
import { catalogMailingListsSettings } from '../../components/pages/catalogMailingLists/Settings'
import Spinner from '../../components/common/Spinner'

class CatalogReportList extends Component {
	constructor(props) {
		super(props);
		this.state = {
		};
		this.deleteList = this.deleteList.bind(this);
	}
	
	componentDidMount() {
		this.props.dispatch(catalogMailingListsActions.getCatalogMailingLists());
	}
	
	deleteList(id) {
		this.props.dispatch(catalogMailingListsActions.deleteCatalogMailingList(id));
	}

	
	
	render() {
		const { loading, catalogMailingLists } = this.props.mailingLists;
		return (
			<div className="middle-box text-center">
				<Link to="/user/catalog-report/new">New</Link>
				<ReactTable
					data={catalogMailingLists}
					loading={loading}
					columns={catalogMailingListsSettings.settingsForTable(this.deleteList)}
				/>

				<Helmet>
					<title>Catalog Mailing Lists</title>
				</Helmet>
			</div>

		)
	}
}

function mapStateToProps(state) {
	return {
		mailingLists: state.catalogMailingLists
	} 
}


export default connect(mapStateToProps)(withRouter(CatalogReportList));